import {useQuery} from 'react-query'
import {BASE_URL} from '../../config'
import axios from 'axios'
import usePaginationCounts from '../../../utils/hooks/usePaginationCounts'
import {useEffect, useState} from 'react'
import {ISubmenu} from './_model'
import {searchItems} from '../../../utils/helperFunction/_helper'
import {ListViewProvider} from '../../../utils/contextProvider/ListViewProvider'
import TableContentHeader from '../../../utils/components/table-content/TableContentHeader'
import TableContent from '../../../utils/components/table-content/TableContent'
import TablePagination from '../../../utils/components/table-content/TablePagination'
import submenuListColumn from './submenuListColumn'

type Props = {
  searchTerm: string
  onSelectSubmenu: (menu: ISubmenu) => void
}

export const GET_SUBMENU_URL = `${BASE_URL}/api/protect/getAllSubmenu`

const SubmenuList = ({searchTerm, onSelectSubmenu}: Props) => {
  const {
    pagination: {page, size, totalElement},
    updatePagination,
    handlePageChange,
    handlePagePerItem,
  } = usePaginationCounts(1, 10)

  const [submenuList, setSubmenuList] = useState<ISubmenu[]>([])

  const {isLoading, data, error} = useQuery({
    queryKey: ['submenuItemList', {page, size}],
    queryFn: async () => {
      const response = await axios.get(GET_SUBMENU_URL, {
        params: {page, size},
      })
      const data = await response.data

      return {
        list: data.data,
        pagination: data.pagenationResponse,
      }
    },
  })

  const handleSelect = (id: number) => {
    console.log(id)
    const selected = submenuList.find((submenu) => submenu.id_submenu === id)

    if (selected) {
      onSelectSubmenu(selected)
    }
  }

  useEffect(() => {
    if (data) {
      const keys: (keyof ISubmenu)[] = ['submenu_name']
      const filtered = searchItems(data.list, searchTerm, keys)

      setSubmenuList(filtered || [])
      updatePagination(data.pagination)
    }
  }, [data, searchTerm])

  return (
    <ListViewProvider isLoading={isLoading} data={submenuList}>
      <TableContentHeader size={size} handlePagePerItem={handlePagePerItem} />
      <>
        <TableContent
          isLoading={isLoading}
          tableData={submenuList}
          tableColumn={submenuListColumn(handleSelect)}
          error={error as Error}
        >
          {isLoading && !data ? (
            <div className='d-flex justify-content-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
            </div>
          ) : (
            <TablePagination
              totalElement={totalElement}
              isLoading={isLoading}
              itemsPerPage={size}
              currentPage={page}
              handlePageChange={handlePageChange}
            />
          )}
        </TableContent>
      </>
    </ListViewProvider>
  )
}

export default SubmenuList
